import uniqueId from 'lodash-es/uniqueId';

export const timeLog = (label, func) => {
    label += ` ${uniqueId()}`;
    console.time(label);
    const val = func();
    console.timeEnd(label);
    return val;
};

const Counter = () => {
    let count = 0;

    return {
        increment: () => count++,
        first: () => count === 1,
        eq: val => val === count,
        lt: val => count < val,
        lte: val => count <= val,
        gt: val => count > val,
        gte: val => count >= val,
    };
};

export const counter = (name = 'default') => {
    if (!Counter.instances) Counter.instances = {};

    const instance = Counter.instances[name]
        ? Counter.instances[name]
        : (Counter.instances[name] = Counter());

    instance.increment();

    return instance;
};
